import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';
import Router, { useRouter } from 'next/router';
import { authFromCookies } from '../utils/authFromCookies';
// import { BotIdClient } from 'botid/client';
import Head from 'next/head';
import 'nprogress/nprogress.css'; //styles of nprogress
import '../assets/CSS/root.css'
import CriticalCss from '../components/UI/CriticalCss';
import '../utils/polyfills'
import { captureAcquisition } from '../utils/utm';
import { isDatadogRumPath } from '../utils/datadogRumPaths';

const GlobalComponent = dynamic(() => import('../components/GlobalComponent'), {
  ssr: false,
});
const WebviewGlobalComponent = dynamic(
    () => import('../components/WebviewGlobalComponent'),
    {
      ssr: true,
    }
);


// const protectedRoutes = [
//   {
//     path: '/signin',
//     method: 'GET',
//   },
//   {
//     path: '/api/generate-hash',
//     method: 'POST',
//   },
//   {
//     path: '/verify_phone',
//     method: 'GET',
//   },
//   {
//     path: '/',
//     method: 'GET',
//   },
//   {
//     path: '/api/verify-botid',
//     method: 'POST',
//   }
// ];
const initDataDog = async () => {

  if(typeof window !== 'undefined') {
    if(isDatadogRumPath(window.location.pathname)) {
      setTimeout(async () => {

        const datadogRum = (await import('@datadog/browser-rum')).datadogRum;
        datadogRum.init({
          applicationId: '63625149-b9e2-4251-bb51-e84bdbdfb63d',
          clientToken: 'pub4977dc696619745bbdd992897fc9c695',
          site: 'datadoghq.eu',
          service: 'faheem-frontend',
          // Specify a version number to identify the deployed version of your application in Datadog
          // version: '1.0.0',
          sampleRate: 100,
          premiumSampleRate: 100,
          trackInteractions: true,
          defaultPrivacyLevel: 'allow',
        });
        datadogRum.startSessionReplayRecording();
        return;
      }, 3000)
    };
  };

  const datadogLogs = (await import('@datadog/browser-logs')).datadogLogs;


  datadogLogs.init({
    clientToken: 'pub4977dc696619745bbdd992897fc9c695',
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sampleRate: 100,
  });


};

const bindNProgress = async () => {

  if(typeof window !== 'undefined') {
    const path = window.location.pathname;
    if(path.includes('/instant-orders')) return;
  };

  const nProgress = (await import('nprogress')).default;

  Router.events.on('routeChangeStart', () => nProgress.start());
  Router.events.on('routeChangeComplete', () => nProgress.done());
  Router.events.on('routeChangeError', () => nProgress.done());
};

initDataDog();
bindNProgress();

const pathsToHideIntercom = [
  'app',
  'buy-hours',
  'cooperation',
  'payment',
  'wallet',
  'apps',
  'search-referals',
  'board',
  'student/match-tutor',
  'intercom-scheduler',
  'intercom-tutor-orders',
  'intercom-tutor-calls',
  'intercom-call-students',
  'intercom-calendar-table',
  'scheduler',
  'intercom-booking',
  'post-message',
  'mobile-booking-flow',
  'university-booking',
  'intercom-booking-flow',
  'mobile-upload-attachment-for-broadcast',
  'student/feedback-form',
  'mobile-booking-details',
  'expired-booking',
  'student/leaderboard',
  'student/points',
  'student/prize-wheel',
  'student/complaints-onboarding',
  'tutor/grades-onboarding',
  'tutor/student-no-balance',
  'tutor/instant-orders',
  'tutor/absence-reason',
  'student/contact-provider',
  'student/pay-dues',
  'mobile-profile',
  'change-phone-number',
  'change-phone-number-unavailable',
  'verify_new_phone',
  'makhfi-report',
  'almkhfai-exams',
  'connectivity-test',
  'workshops/[id]',
  'workshops/[id]/discussions',
  'workshops/[id]/create-discussion',
  'workshops/[id]/discussions/[discussionId]',
  'mobile-report-booking',
  'session_details',
  'student/post-session-analysis/[sessionClassId]',
  'mobile-booking-cancel',
  'makhfi-page',
  'upload-1607496161569',
  'student/homework',
  'takaful-register',
  'takaful-register/success',
  'student/join-session',
  'transferred-tutor-booking',
  'tutor/first-booking-message',
  'test-connectivity',
  'sales/booking',
  'tutor/regular-class-onboarding',
  'student/expired-trial-booking',
  'consultation-booking-success',
  'mobile-low-balance',
  'university-subject-booking',
  'student/calendar',
  'sales/login'
];

const webviewRoutes = [
  '/submit-application',
  '/tutor/reschedule-onboarding',
  '/mobile-booking-details',
  '/tutor/student-no-balance',
  '/buy-hours',
  '/tutor/instant-orders',
  '/tutor/absence-reason',
  '/student/contact-provider',
  '/student/pay-dues',
  '/mobile-profile',
  '/workshops/[id]',
  '/workshops/[id]/discussions',
  '/workshops/[id]/create-discussion',
  '/workshops/[id]/discussions/[discussionId]',
  '/mobile-report-booking',
  '/session_details',
  '/mobile-booking-cancel',
  '/makhfi-page',
  '/upload-1607496161569',
  '/student/homework',
  '/takaful-register',
  '/takaful-register/success',
  '/transferred-tutor-booking',
  '/student/join-session',
  '/transferred-tutor-booking',
  '/tutor/first-booking-message',
  '/tutor/regular-class-onboarding',
  '/student/expired-trial-booking',
  '/payment',
  '/tutor/demo-session-recording',
  '/mobile-low-balance',
  '/consultation-booking-success',
  '/university-subject-booking',
  '/student/calendar'
];

const pathsForNewStore = [
  '/buy-hours',
];
export const isAuth = authFromCookies;

const App = ({ Component, pageProps, ...rest }) => {
  const isWebView = pageProps?.isWebView;
  const router = useRouter();
  const { pathname } = router;

  useEffect(() => {
    try {
      captureAcquisition(router.query);
    } catch {
      // Never block the user flow over tracking
    }
  }, [router.query]);

  useEffect(() => {
    const isHomePage = pathname === '/';
    document.body.classList.toggle('page-home', isHomePage);
    return () => document.body.classList.remove('page-home');
  }, [pathname]);

  useEffect(() => {
    window.BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

    const showIntercom = pathsToHideIntercom.every(
        (path) => !pathname.includes(path)
    );

    if (pathname?.includes('under_approval') || showIntercom) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        setTimeout(() => {
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s);
          j.async = true;
          j.src = '/intercom.js';
          f.parentNode.insertBefore(j, f);
        }, 4000);
      })(window, document, 'script', 'dataLayer', 'GTM-P893KRL');
    }
  }, []);
  const isUsingNewStore = pathsForNewStore.includes(pathname);

  if (isWebView) {
    return (
      <WebviewGlobalComponent>
        <CriticalCss />
        <Component {...pageProps} />
      </WebviewGlobalComponent>
    );
  }

  if (!isWebView) {
    import('../assets/CSS/mainStyle.css');
    import('../assets/CSS/home-page.css');
    import('../assets/CSS/login.css');
    import('../assets/CSS/header.css');
    import('../assets/CSS/signUp.css');
    import('../assets/CSS/orders.css');
    import('../assets/CSS/search-page.css');
    import('../assets/CSS/dashboard-setting.css');
    import('../assets/CSS/post-job.css');
    import('../assets/CSS/react-datepicker.css');
    import('../assets/CSS/profile.css');
    import('../assets/CSS/contact.css');
    import('../assets/CSS/become-a-tutor.css');
    import('../assets/CSS/about-us.css');
    import('../assets/CSS/chat.css');

    return (
        <>
          <Head>
            {/* <BotIdClient protect={protectedRoutes} /> */}
            <link
                rel="stylesheet"
                href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.7.1/css/all.min.css"
            ></link>
            <link
                rel="stylesheet"
                href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
            />
            <link
              rel="stylesheet"
              href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.5/dist/css/bootstrap.min.css"
              integrity="sha384-SgOJa3DmI69IUzQ2PVdRZhwQ+dy64/BUtbMJw1MZ8t5HZApcHrRKUc4W0kG879m7"
              crossorigin="anonymous"
            />

      <script
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s),
                  dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;
              j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-T9WCSJ5L');
            `,
          }}
        />
          </Head>

          <noscript
          dangerouslySetInnerHTML={{
            __html: `
              <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-T9WCSJ5L"
              height="0" width="0" style="display:none;visibility:hidden"></iframe>
            `,
          }}
        />
          <GlobalComponent isAuth={rest.isAuth}>
            <Component {...pageProps} />
          </GlobalComponent>
          <script
              src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
              integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
              crossOrigin="anonymous"
          ></script>
          <script
              src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"
              integrity="sha384-B4gt1jrGC7Jh4AgTPSdUtOBvfO8shuf57BaghqFfPlYxofvL8/KUEfYiJOMMV+rV"
              crossOrigin="anonymous"
          ></script>
        </>
    );
  }
};

App.getInitialProps = async ({ Component, ctx, ...rest }) => {
  const path = ctx.pathname;
  const isWebView = webviewRoutes.includes(path);
  return {
    pageProps: {
      // Call page-level getInitialProps
      ...(Component.getInitialProps
          ? await Component.getInitialProps(ctx)
          : {}),
      // Some custom thing for all pages
      appProp: path,
      isWebView,
    },
    ...(!isWebView && { isAuth: isAuth(ctx) }),
  };
};

export default App;
